<template>
  <div class="cursor-pointer">
    <div class="label" v-if="textFloat">
      {{ textFloat }} <span v-if="isRequired" class="text-danger">*</span>
    </div>
    <div class="d-flex align-items-center">
      <input
        type="color"
        id="head"
        :ref="name"
        :name="name"
        :value="value"
        @input="$emit('input', $event.target.value)"
        :disabled="disabled"
      />
      <div class="color-select" @click="toggleColorPicker()">
        <label class="mb-0">{{ value || "Select Color" }}</label>
      </div>
    </div>
    <div v-if="v && v.$error">
      <span class="text-error" v-if="v.required == false">กรุณากรอกข้อมูล</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    textFloat: {
      required: true,
      type: String,
    },
    value: {
      required: false,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    v: {
      required: false,
      type: Object,
    },
  },
  methods: {
    toggleColorPicker() {
      this.$refs[this.name].click();
    },
  },
};
</script>

<style>
.color-select {
  /* border: 1px solid #ccc; */
  background-color: white;
  border: 1px solid #d8dbe0;
  border-radius: 2px;
  padding: 3px 13px;
  height: 35px;
  display: flex;
  align-items: center;
  min-width: 100px;
  white-space: nowrap;
  margin-left: -3px;
  z-index: 1;
  border-left: none;
}
input[type="color"] {
  z-index: 2;
  height: 35px;
  /* border-radius: unset; */
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  border-color: #d8dbe0;
}

.label {
  color: #16274a;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
  width: 100%;
}

.cursor-pointer {
  cursor: pointer;
}

.text-error {
  color: #ff0000;
  font-size: 14px;
}
</style>
